import _ from 'lodash';

class PosHelper {
    getTotalsFromCart(cart){
        if(cart) {
            return {
                amount: _.sum(cart, (product) => product.price),
                tax: _.sum(cart, (product) => product.tax)
            }
        }
        return {amount: 0.00, tax: 0.00}
    }
}

export default new PosHelper();
